import React from 'react';
import { Element, ConnectionPoint } from '@/types/elements';
import { getElementConnectionPoints } from '@/utils/geometry/connections';

interface ConnectionPointsProps {
  element: Element;
  zoom: number;
  isHovered: boolean;
}

const ConnectionPointDot: React.FC<{ point: ConnectionPoint; zoom: number }> = ({ point, zoom }) => {
  const radius = 5 / zoom;
  const strokeWidth = 1 / zoom;

  return (
    <circle
      cx={point.x}
      cy={point.y}
      r={radius}
      fill="rgba(100, 100, 255, 0.7)"
      stroke="rgba(255, 255, 255, 0.9)"
      strokeWidth={strokeWidth}
      style={{ pointerEvents: 'none' }}
    />
  );
};

export const ConnectionPoints: React.FC<ConnectionPointsProps> = ({ element, zoom, isHovered }) => {
  if (!isHovered) {
    return null;
  }

  const connectionPoints = getElementConnectionPoints(element);

  return (
    <g>
      {connectionPoints.map((point) => (
        <ConnectionPointDot key={point.id} point={point} zoom={zoom} />
      ))}
    </g>
  );
};